import { Icon } from "@vds/icons";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

export const DeleteOrganizationModal = (props) => {
  const { message, title, onConfirm, onExit, setShowDeleteOrg, showDeleteOrg } =
    props;
  return (
    <>
      <Modal
        opened={showDeleteOrg}
        disableOutsideClick={true}
        ariaLabel={`${title} Modal`}
        surface="light"
        fullScreenDialog={false}
        hideCloseButton={true}
        disableAnimation={false}
        onClose={setShowDeleteOrg}
        width={"600px"}
        closeButton={
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
            }}
            onClick={onExit}
          >
            <Icon name="close" />
          </div>
        }
      >
        <ModalTitle>
          <Title size="large">{title}</Title>
        </ModalTitle>
        <ModalBody>
          <Body size="large">
            {message || "Are you sure you want to delete the Organization"}
          </Body>
        </ModalBody>
        <ModalFooter
          buttonData={{
            close: {
              width: "100%",
              children: "Yes, delete",
              onClick: onConfirm,
            },
            primary: {
              children: "No, cancel",
              width: "100%",
              onClick: onExit,
            },
          }}
        />
      </Modal>
    </>
  );
};
